import React from 'react'
import { Typography } from 'transfix-ui/core'
import { Card } from 'transfix-ui'

interface ITestResultsProps {
  title: string
  output: string
}

export const TestResultField = ({ output, title }: ITestResultsProps) => {
  return (
    <Card collapsible collapsedByDefault mini title={title}>
      <Typography variant='caption'>{output}</Typography>
    </Card>
  )
}
